import React from 'react'
import Card from '../components/Card'
import { ReactSVG } from 'react-svg'
import SelectBtns from '../components/SelectBtns'
import Btn from '../components/Btn'
import { Link } from 'react-router-dom'
import TextField from '../components/TextField'
import { useForm } from 'react-hook-form'
import {
  EMAIL_VALIDATION_PATTERN,
  PHONE_VALIDATION_PATTERN,
  SNILS_VALIDATION_PATTERN,
  NAME_VALIDATION_PATTERN
} from '../constants'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import BtnIcon from '../components/BtnIcon'
import { useAxios } from '../hooks/useAxios'
import { signUp } from '../api/signUp'
import RadioGroup from '../components/RadioGroup'
import CheckboxSingle from '../components/CheckboxSingle'

export interface IFormData {
  role?: string
  email?: string
  phone?: string
  password?: string
  passwordRepeat?: string
  name?: string
  lastName?: string
  secondName?: string
  birthday?: string
  gender?: string
  snils?: string
}

const ROLES = ['Абитуриент', 'Студент', 'Выпускник', 'Сотрудник ГУАП', 'Партнер']

function SignUpPage(): React.ReactElement {
  const [stage, setStage] = React.useState(1)
  const [done, setDone] = React.useState(false)
  const [role, setRole] = React.useState('')
  const formData = React.useRef<any>({})

  const {
    control,
    formState: { errors },
    handleSubmit
  } = useForm({
    defaultValues: {
      email: '',
      phone: '',
      password: '',
      passwordRepeat: ''
    }
  })
  const {
    control: control2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    watch
  } = useForm({
    defaultValues: {
      name: '',
      lastName: '',
      secondName: '',
      birthday: '',
      gender: '',
      snils: '',
      agreement: false,
      foreignCitizen: false
    }
  })
  const { loading, error, fire } = useAxios()
  const isForeignCitizen = watch('foreignCitizen')

  const onSubmit = (data: any): void => {
    setStage(3)

    formData.current = data
  }

  const onFinish = async (data: any): Promise<void> => {
    formData.current = { ...formData.current, ...data, role }

    const { error } = await fire(
      signUp({
        ...formData.current,
        passwordRepeat: undefined,
        agreement: undefined
      })
    )

    if (!error) {
      setDone(true)
    }
  }

  if (done) {
    return (
      <div className="auth-layout-view" style={{ maxWidth: '67rem' }}>
        <Card className="auth-layout-view__card auth-card">
          <header className="auth-card__head u-flexCol mb-2">
            <h1>
              Регистрация на{' '}
              <ReactSVG
                wrapper="span"
                className="auth-logo"
                src="/i/logo-sm.svg"
              />
            </h1>
          </header>
          <div className="auth-card__content">
            <div className="auth-card__content">
              <p>{`Электоронное письмо с подтверждением отправлено на почту: ${formData.current.email}. Проверьте почтовый ящик и следуйте дальнейшим инструкциям.`}</p>

              <div className="u-flex u-flexJustifyCenter mt-md-8 mt-sm-6">
                <Btn to={'/auth'}>На главную</Btn>
              </div>
            </div>
          </div>
        </Card>
      </div>
    )
  }

  return (
    <div className="auth-layout-view" style={{ maxWidth: '67rem' }}>
      <Card className="auth-layout-view__card auth-card">
        <header className="auth-card__head u-flexCol mb-2">
          <h1>
            Регистрация на{' '}
            <ReactSVG
              wrapper="span"
              className="auth-logo"
              src="/i/logo-sm.svg"
            />
          </h1>

          {stage > 1 ? (
            <div className="auth-card__head-control _left-side">
              <BtnIcon
                onClick={() => {
                  setStage(stage - 1)
                }}
                filled
              >
                <ReactSVG
                  src={'/i/svg/arrow-left.svg'}
                  wrapper={'span'}
                ></ReactSVG>
              </BtnIcon>
            </div>
          ) : null}
        </header>
        {stage !== 2 || role !== 'Студент' ? (
          <p className={'mb-md-8 mb-sm-6'}>
            {stage === 1 ? 'Выберите вашу роль' : 'Укажите информацию о себе'}
          </p>
        ) : undefined}

        {stage === 1 ? (
          <div className="auth-card__content">
            <SelectBtns
              value={role}
              onChange={(value) => {
                setRole(value)
              }}
              items={ROLES}
            ></SelectBtns>

            <div className="u-flex u-flexJustifyCenter mt-md-8 mt-sm-6">
              <Btn
                disabled={!role}
                onClick={() => {
                  setStage(2)
                }}
              >
                Продолжить
              </Btn>
            </div>
          </div>
        ) : stage === 2 ? (
          <>
            {role === 'Студент' ? (
              <div
                className={
                  'auth-card__content mt-md-6 mt-sm-4 u-flex u-flexCol u-flexAlignItemsCenter'
                }
              >
                <p>
                  Студентам ГУАП необходимо авторизоваться на платформе с
                  помощью учетной записи в личном кабинете университета. Для
                  этого выберите «Вход через соцсети» на странице авторизации.{' '}
                </p>
                <Btn className={'mt-md-6 mt-sm-4'} to={'/auth'}>
                  Войти
                </Btn>
              </div>
            ) : (
              <div className="auth-card__content">
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="auth-card-form"
                >
                  <div className="auth-card-form__fields">
                    <TextField
                      key={'email'}
                      control={control}
                      rules={{
                        required: true,
                        pattern: {
                          value: EMAIL_VALIDATION_PATTERN,
                          message: ''
                        }
                      }}
                      hasError={!!errors.email}
                      errorText={
                        errors.email?.type === 'pattern'
                          ? ERROR_DICT.email
                          : errorDict(errors.email)
                      }
                      name="email"
                      type="email"
                      label="Электронная почта"
                      required
                    ></TextField>
                    <TextField
                      key={'phone'}
                      mask={'+7 (999) 999-99-99'}
                      control={control}
                      rules={{
                        required: true,
                        pattern: {
                          value: PHONE_VALIDATION_PATTERN,
                          message: ''
                        }
                      }}
                      hasError={!!errors.phone}
                      errorText={
                        errors.phone?.type === 'pattern'
                          ? ERROR_DICT.phone
                          : errorDict(errors.phone)
                      }
                      name="phone"
                      type="tel"
                      label="Номер телефона"
                      required
                    ></TextField>
                    <TextField
                      key={'password'}
                      autocomplete={'on'}
                      name="password"
                      control={control}
                      rules={{ required: true, minLength: 6 }}
                      hasError={!!errors.password}
                      errorText={
                        errors.password?.type === 'minLength'
                          ? ERROR_DICT.passwordMinLength
                          : errorDict(errors.password)
                      }
                      type={'password'}
                      label={'Пароль'}
                      required
                      helpText={'Не менее 6 символов'}
                    ></TextField>
                    <TextField
                      key={'passwordRepeat'}
                      autocomplete={'on'}
                      name="passwordRepeat"
                      control={control}
                      rules={{
                        required: true,
                        validate: (value, formValues) => {
                          const { password } = formValues

                          return value === password
                        }
                      }}
                      hasError={!!errors.passwordRepeat}
                      errorText={
                        errors.passwordRepeat?.type === 'validate'
                          ? ERROR_DICT.passwordsMatches
                          : errorDict(errors.passwordRepeat)
                      }
                      type={'password'}
                      label={'Повторите пароль'}
                      required
                    ></TextField>
                  </div>

                  <footer className="auth-card-form__foot">
                    <Btn type="submit">Продолжить</Btn>
                  </footer>
                </form>
              </div>
            )}
          </>
        ) : (
          <div className="auth-card__content">
            <form onSubmit={handleSubmit2(onFinish)} className="auth-card-form">
              <div className="auth-card-form__fields">
                <TextField
                  key={'lastName'}
                  control={control2}
                  rules={{
                    required: true,
                    pattern: {
                      value: NAME_VALIDATION_PATTERN,
                      message: ''
                    }
                  }}
                  hasError={!!errors2.lastName}
                  errorText={errorDict(errors2.lastName)}
                  name="lastName"
                  label="Фамилия"
                  required
                ></TextField>
                <TextField
                  key={'name'}
                  control={control2}
                  rules={{
                    required: true,
                    pattern: {
                      value: NAME_VALIDATION_PATTERN,
                      message: ''
                    }
                  }}
                  hasError={!!errors2.name}
                  errorText={errorDict(errors2.name)}
                  name="name"
                  label="Имя"
                  required
                ></TextField>
                <TextField
                  key={'secondName'}
                  control={control2}
                  rules={{
                    pattern: {
                      value: NAME_VALIDATION_PATTERN,
                      message: ''
                    }
                  }}
                  hasError={!!errors2.secondName}
                  errorText={errorDict(errors2.secondName)}
                  name="secondName"
                  label="Отчество"
                ></TextField>
                <TextField
                  key={'birthday'}
                  control={control2}
                  rules={{ required: true }}
                  hasError={!!errors2.birthday}
                  errorText={errorDict(errors2.birthday)}
                  name="birthday"
                  type="date"
                  label="Дата рождения"
                  required
                ></TextField>
                <RadioGroup
                  key={'gender'}
                  name={'gender'}
                  control={control2}
                  items={['Мужской', 'Женский']}
                  rules={{ required: true }}
                  hasError={!!errors2.gender}
                  errorText={errorDict(errors2.gender)}
                  required
                ></RadioGroup>
                <CheckboxSingle name={'foreignCitizen'} control={control2}>
                  Не гражданин РФ
                </CheckboxSingle>
                <TextField
                  key={'snils'}
                  mask={'999-999-999 99'}
                  control={control2}
                  rules={{
                    validate: (value) => {
                      if (isForeignCitizen) return true

                      return SNILS_VALIDATION_PATTERN.test(value)
                    }
                  }}
                  hasError={!!errors2.snils}
                  errorText={ERROR_DICT.snils}
                  name="snils"
                  type="text"
                  label="CНИЛС"
                  required={!isForeignCitizen}
                  disabled={isForeignCitizen}
                ></TextField>
                <CheckboxSingle
                  key={'agreement'}
                  name={'agreement'}
                  control={control2}
                  rules={{ validate: (value) => value === true }}
                  hasError={!!errors2.agreement}
                  required
                >
                  <span className={'text-body text-content'}>
                    Я согласен(-на) на обработку персональных данных в
                    соответствии с{' '}
                    <a
                      href="https://docs.guap.ru/pr_guap_05-313-20.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Политикой в отношении обработки персональных данных
                    </a>
                  </span>
                </CheckboxSingle>
              </div>

              {error ? (
                <div
                  style={{ width: '100%' }}
                  className={'error-text text-align-left mb-md-10 mb-sm-8'}
                >
                  {error?.message}
                </div>
              ) : null}

              <footer className="auth-card-form__foot">
                <Btn disabled={loading} loading={loading} type="submit">
                  Регистрация
                </Btn>
              </footer>
            </form>
          </div>
        )}
      </Card>

      <footer className="auth-layout-view__foot">
        Уже зарегистрировались?{' '}
        <Link className={'link text-body-bold'} to={'/auth'}>
          Войти
        </Link>
      </footer>
    </div>
  )
}

export default SignUpPage
